// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"179":"98432ea7","628":"04fea4fe","919":"64f1fed1","972":"b8ca457b"}[chunkId] + ".chunk.js";
};